module.exports = __webpack_public_path__ + "img/dr_mcphee.708c6181.jpg";